// extracted by mini-css-extract-plugin
module.exports = {"body":"ChooseNetworkModal_body__2QKmK"};